import './styles/global.css';
import '@arpm/ui/fonts.css';
import '@arpm/ui/tokens.css';
import '@arpm/ui/styles';

import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { i18n } from './i18n/index.js';
import { router } from './router/index.js';
import { useAuthStore } from './stores/auth.js';

async function bootstrap() {
  const app = createApp(App);
  app.use(createPinia());
  app.use(i18n);
  app.use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false },
      },
    },
  });

  const auth = useAuthStore();
  await auth.initialize();

  app.use(router);
  app.mount('#app');
}

/**
 * Service worker — только для станции контрольной точки.
 *
 * Админке кэш оболочки не нужен и вреден: обновление выкатывается по нескольку
 * раз в день. А планшет на входе должен открываться и без сети.
 */
if ('serviceWorker' in navigator && window.location.pathname.startsWith('/scan')) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/scan' });
  });
}

bootstrap().catch((err) => {
  // eslint-disable-next-line no-console
  console.error('Не удалось загрузить accreditation-web', err);
});
